import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { getTransactions } from '../../../MyApi/transactions'
import DataTable from '../../UI/table/DataTable'
import StatusBadge from "../../UI/statusBadge"
import LoadingSpinner from '../../UI/spinner'
import { formatPrice } from '../../../utils/formatPrice'

const TransactionsInfo = ({id}) => {
    const [current_page,setCurrentPage]=useState(1)
    const {data ,isLoading}=useQuery(["getTransactions", id ,current_page],()=>getTransactions(current_page, {store_id: id}))  
    const transactions =data?.data?.transactions ||{}
      const totalItems = data?.data?.pagination?.total || 0;
  const lastPage = data?.data?.pagination?.last_page || 0;
    const transactionsColumns = [
    { label: "معرف العملية", accessor: "id" },
    { label: "المبلغ", accessor: "amount" },
    { label: "النوع", accessor: "type" },
    { label: "الوصف", accessor: "description" },
    { label: "الحالة", accessor: "status" },
    { label: "التاريخ", accessor: "created_at" },
  ]

  return (
    <div>
        <DataTable  isLoading={isLoading} columns={transactionsColumns}  data={transactions} totalItems={totalItems} itemsPerPage={lastPage} currentPage={current_page} setCurrentPage={setCurrentPage}/>
    </div>
  )
}

export default TransactionsInfo